<template>
  <SingleItem :collectionItem="collectionItem" v-if="collectionItem.type === 'single'"/>
  <DoubleItem :collectionItem="collectionItem" v-else-if="collectionItem.type === 'double'"/>
  <TripleItem :collectionItem="collectionItem" v-else-if="collectionItem.type === 'triple' || collectionItem.type === 'triple-reverse'" />
</template>

<script>
import SingleItem from '@/components/sections/MainPage/CollectionItemGrids/SingleItem';
import DoubleItem from '@/components/sections/MainPage/CollectionItemGrids/DoubleItem';
import TripleItem from '@/components/sections/MainPage/CollectionItemGrids/TripleItem';

export default {
  name: "CollectionItem",
  components:{
    SingleItem,
    DoubleItem,
    TripleItem
  },
  props: {
    collectionItem: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>